import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../../../../../core';
import { Cliente } from '../../../../../cliente';
import { ClienteCentralCompra } from '../../../cliente-central-compra';
import { ClienteCentralCompraHttpService } from '../../../services';
import { ClienteCentralCompraParticipante } from '../../cliente-central-compra-participante';
import { TypeaheadClienteComponent } from '../../../../typeahead';
import { ClienteCentralCompraParticipanteFormComponent } from '../cliente-central-compra-participante-form.component';

@Component({
    selector: 'sgt-cliente-central-compra-participante-form-insert',
    templateUrl: './cliente-central-compra-participante-form-insert.component.html',
    styleUrls: ['./cliente-central-compra-participante-form-insert.component.less']
})
export class ClienteCentralCompraParticipanteFormInsertComponent {
    isLoadingCentralCompras: boolean;
    isLoadedCentralCompras: boolean;
    centralCompras: ClienteCentralCompra;

    centralCompraParticipante: Cliente
    participante: ClienteCentralCompraParticipante;

    @ViewChild('form') form: NgForm;
    @ViewChild('formParticipantes') formParticipantes: ClienteCentralCompraParticipanteFormComponent;
    @ViewChild('typeaeadCentralCompras') typeaeadCentralCompras: TypeaheadClienteComponent;

    constructor(private messageService: MessageService,
                private clienteCentralCompraHttpService: ClienteCentralCompraHttpService) { }

    /** Pepara para inserir o participante informado após a sua central de compras ser selecionada */
    insert(participante: ClienteCentralCompraParticipante) {
        this.participante = participante;
        this.setFocusCentralCompras();
    }

    /** Ao selecionar a central de compras */
    onSelectCentralCompras() {
        if (this.centralCompraParticipante) {
            this.loadCentralCompras(this.centralCompraParticipante.id)
                .then(() => {
                    // Inserindo o participante informado
                    this.formParticipantes?.insert(this.participante);
                })
                .catch(() => {});
        } else {
            this.centralCompras = null;
        }
    }

    /** Ao remover a central de compras selecionada */
    onClearCentralCompras() {
        this.centralCompras = null;
    }

    /** Seta o foco no typeahead para selecionar a central de compras */
    private setFocusCentralCompras() {
        this.typeaeadCentralCompras?.setFocus();
    }

    /** Carrega a central de compras */
    private loadCentralCompras(idClienteCentralCompras: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.isLoadingCentralCompras = true;
            this.isLoadedCentralCompras = false;
            this.clienteCentralCompraHttpService.load(idClienteCentralCompras)
                .pipe(
                    take(1)
                )
                .subscribe(
                    centralCompras => {
                        this.centralCompras = centralCompras;
                        this.isLoadingCentralCompras = false;
                        this.isLoadedCentralCompras = true;
                        setTimeout(() => resolve(), 200);
                    },
                    () => {
                        this.centralCompras = null;
                        this.isLoadingCentralCompras = false;
                        this.isLoadedCentralCompras = true;
                        reject();
                    }
                );
        });
    }

    /** Valida se as informações estão corretas para pode salvar */
    private isValid(): boolean {
        // Inserindo e não informado a central de compras
        if (!this.centralCompraParticipante) {
            this.messageService.info('Para salvar é necessário selecionar a central de compras', 'Informação');
            this.setFocusCentralCompras();
            return false;
        }

        // Validando os participantes
        if (!this.formParticipantes?.isValid()) {
            return false;
        }

        return true;
    }

    /** Salva a central de compras */
    save(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            if (!this.isValid()) {
                reject();
                return;
            }

            this.clienteCentralCompraHttpService.save(this.centralCompras)
                .subscribe(
                        () => {
                            this.messageService.success('', 'Central de Compras salva com sucesso');
                            resolve();
                        },
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao salvar a central de compras', error);
                        reject(error);
                    }
                )
        });
    }
}
